// ------------------------------------
// Constants
// ------------------------------------
const LOADING_CONTENT_SET = 'LOADING_CONTENT_SET';

// ------------------------------------
// Actions
// ------------------------------------
function setLoadingContent(value = true) {
  return {
    type    : LOADING_CONTENT_SET,
    payload : value
  }
}

export {
  setLoadingContent
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [LOADING_CONTENT_SET]  : (state, action) => action.payload,
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = false;

export default function loadingContentReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/layouts/Content/modules/loadingContent.js